import HeaderSettings from './HeaderSettings';
import EpisodeNumber from './EpisodeNumber';
import PrePublishHeader from './prepublish/PrePublishHeader';
import PreUpdateHeaderComponent from './prepublish/PreUpdateHeader';
import EpisodeDuration from './EpisodeDuration';
import PodcastTitle from './PodcastTitle';
import VideoPlayer from '../document-settings/VideoPlayer/VideoPlayer';

const DisplayComponent = () => {
	return (
		<>
			<HeaderSettings.Slot />
			<PreUpdateHeaderComponent />
			<PrePublishHeader />
			<EpisodeNumber />
			<EpisodeDuration />
			<VideoPlayer />
			<PodcastTitle />
		</>
	);
};

export default DisplayComponent;
